module.exports = __webpack_public_path__ + "static/BT-desktop-10-aeadbc0368861a3ad7ab230b18f7c060.jpg";